import { render } from "./KriteriaPenilaian.vue?vue&type=template&id=490470c1"
import script from "./KriteriaPenilaian.vue?vue&type=script&lang=js"
export * from "./KriteriaPenilaian.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__